'use client';

import { useFavorites, FavoriteItem } from '@/hooks/useFavorites';
import styles from './FavoriteButton.module.scss';
import { useTranslations } from 'next-intl';

interface FavoriteButtonProps {
  id: string;
  slug: string;
  name: string;
  type: FavoriteItem['type'];
  variant?: 'default' | 'compact';
  className?: string;
}

export default function FavoriteButton({
  id,
  slug,
  name,
  type,
  variant = 'default',
  className = '',
}: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite, isLoaded } = useFavorites();
  const t = useTranslations('parksList');

  if (!isLoaded) {
    return null; // or skeleton
  }

  const favorite = isFavorite(id, type);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    // Toggle favorite (add or remove)
    toggleFavorite({ id, slug, name, type });
  };

  return (
    <button
      onClick={handleClick}
      className={`${styles.favoriteButton} ${styles[variant]} ${favorite ? styles.active : ''} ${className}`}
      aria-label={favorite ? t('removeFromFavorites') : t('addToFavorites')}
      title={favorite ? t('removeFromFavorites') : t('addToFavorites')}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill={favorite ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    </button>
  );
}
